import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createArchitecture = (architecture) => ({
  type: ActionTypes.ARCHITECTURE_CREATE,
  payload: {
    architecture,
  },
});

export const deleteArchitecture = (id) => ({
  type: ActionTypes.ARCHITECTURE_DELETE,
  payload: {
    id,
  },
});

export const fetchArchitecture = (factoryId) => ({
  type: ActionTypes.ARCHITECTURE_FETCH,
  payload: {
    factoryId,
  },
});

/* Events */

export const createArchitectureRequested = (localId, data) => ({
  type: ActionTypes.ARCHITECTURE_CREATE_REQUESTED,
  payload: {
    localId,
    data,
  },
});

export const createArchitectureSucceeded = (localId, architecture) => ({
  type: ActionTypes.ARCHITECTURE_CREATE_SUCCEEDED,
  payload: {
    localId,
    architecture,
  },
});

export const createArchitectureFailed = (localId, error) => ({
  type: ActionTypes.ARCHITECTURE_CREATE_FAILED,
  payload: {
    localId,
    error,
  },
});

export const createArchitectureReceived = (architecture) => ({
  type: ActionTypes.ARCHITECTURE_CREATE_RECEIVED,
  payload: {
    architecture,
  },
});

export const deleteArchitectureRequested = (id) => ({
  type: ActionTypes.ARCHITECTURE_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteArchitectureSucceeded = (architecture) => ({
  type: ActionTypes.ARCHITECTURE_DELETE_SUCCEEDED,
  payload: {
    architecture,
  },
});

export const deleteArchitectureFailed = (id, error) => ({
  type: ActionTypes.ARCHITECTURE_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteArchitectureReceived = (architecture) => ({
  type: ActionTypes.ARCHITECTURE_DELETE_RECEIVED,
  payload: {
    architecture,
  },
});

export const fetchArchitectureRequested = (factoryId) => ({
  type: ActionTypes.ARCHITECTURE_FETCH_REQUESTED,
  payload: {
    factoryId,
  },
});

export const fetchArchitectureSucceeded = (architectures) => ({
  type: ActionTypes.ARCHITECTURE_FETCH_SUCCEEDED,
  payload: {
    architectures,
  },
});

export const fetchArchitectureFailed = (error) => ({
  type: ActionTypes.ARCHITECTURE_FETCH_FAILED,
  payload: {
    error,
  },
});

export const fetchArchitectureReceived = (architectures) => ({
  type: ActionTypes.ARCHITECTURE_FETCH_RECEIVED,
  payload: {
    architectures,
  },
});
